import { instanceAxios } from "@utils/axioswithintercept";
import { BaseUrl } from "../env";
import { CallApi } from "../utils/CallApi";

export async function loginService(data: { email: string, password: string, company_id: string }) {
    return instanceAxios.post(`/login`, data)

}

export function getProfileService() {
    return instanceAxios.get('/profile')
}

export function refreshTokenService(data: { email: string, company_id: string, refresh_token: string }) {
    return instanceAxios.post('/refresh-token', data)
}
